/**
 * Configuration for organizations in this app.
 */
/* tslint:disable */
module.exports = {
  public: {
    ORGANIZATIONS_SEARCH_PAGE: '/organizations',
    ORGANIZATIONS_SEARCH_LISTING_NUMBER: 12,
    FACETS: [
      {
        title: 'Occupations',
        fieldName: 'field_org_occupational_fields_parents_all',
        vid: 'occupational_fields',
        multiple: true,
        operator: 'OR',
      },
      {
        title: 'Industry',
        fieldName: 'field_org_industry',
        vid: 'industry',
        multiple: true,
        operator: 'OR',
      },
      {
        title: 'Field of studies',
        fieldName: 'field_org_field_of_studies_parents_all',
        vid: 'field_of_studies',
        multiple: true,
        operator: 'OR',
      },
    ],
    SEO: {
      CLEAN_FACETS_ORDER: [
        'field_org_industry',
        'field_org_occupational_fields_parents_all',
        'field_org_field_of_studies_parents_all',
      ],
      CLEAN_FACETS_NUMBER: 3,
      NO_INDEX_EMPTY_PAGE: true,
    },
    ORGANIZATION_GROUP_FIELDS: {
      personal_info: {
        key: 'personal_info',
        name: 'Personal information',
        description: `Provide your personal information.
    This information is not public and will only be used for invoicing and other
    account related actions.`,
        fields: {
          org_base_salutation: 'salutation',
          org_base_firstname: 'firstName',
          org_base_lastname: 'lastName',
          field_org_base_phone: 'phone',
          field_org_base_position: 'position',
        },
      },
      company_info: {
        key: 'company_info',
        name: 'Company information',
        description: `Provide information about your company. This information is used publicly on your company profile
    page once you publish it.`,
        fields: {
          label: 'name',
          field_org_base_address: {
            name: 'address',
            fields: {
              countryCode: 'countryCode',
              addressLine1: 'addressLine1',
              addressLine2: 'addressLine2',
              addressLine3: 'addressLine3',
              administrativeArea: 'administrativeArea',
              locality: 'locality',
              postalCode: 'zip',
            },
          },
        },
      },
    },
    ORGANIZATION_PAGE_FIELDS: {
      info: {
        key: 'organization_info',
        name: 'Organization information',
        description: `Provide your organization basic information such as name,
        logo address and social accounts.`,
        fields: {
          title: 'name',
          field_org_alternative_name: 'alternativeName',
          field_org_logo: 'logo',
          field_org_cover: 'cover',
          field_org_address: {
            name: 'organizationLocation',
            fields: {
              countryCode: 'countryCode',
              addressLine1: 'addressLine1',
              addressLine2: 'addressLine2',
              administrativeArea: 'administrativeArea',
              locality: 'locality',
              postalCode: 'zip',
            },
          },
          field_org_website: 'website',
          field_org_facebook: 'facebookProfile',
          field_org_twitter: 'twitterProfile',
          field_org_linkedin: 'linkedinProfile',
          field_org_youtube: 'youtubeProfile',
          field_org_xing: 'xingProfile',
          field_org_instagram: 'instagramProfile',
          field_org_tiktok: 'tiktokProfile',
          field_org_bluesky: 'blueSkyProfile',
        },
      },
      about: {
        key: 'organization_about_us',
        name: 'About us',
        description: `Provide a longer description of the company.`,
        fields: {
          field_org_presentation: 'presentation',
          field_org_industry: 'industry',
          field_org_size: 'size',
          field_org_occupational_fields: 'occupation',
          field_org_field_of_studies: 'fieldsOfStudy',
        },
      },
      benefits: {
        key: 'organization_benefits',
        name: 'Organization benefits',
        description: `Provide organization benefits.`,
        fields: {
          field_org_benefits: 'benefits',
        },
      },
      contact: {
        key: 'organization_contact_persons',
        name: 'Contact people',
        description: `Provide about people in the organization that can be contacted by applicants.`,
        fields: {
          field_org_salutation: 'salutation',
          field_org_firstname: 'firstName',
          field_org_lastname: 'lastName',
          field_org_contact_photo: 'photo',
          field_org_contact_email: 'email',
          field_org_contact_position: 'position',
          field_org_phone: 'phone',
          field_org_contact_linkedin: 'linkedinProfile',
          field_org_contact_info: 'contactInfo',
        },
      },
      gallery: {
        key: 'organization_gallery',
        name: 'Gallery',
        description: `Provide images of your organization.`,
        fields: {
          field_org_gallery: 'gallery',
        },
      },
      videos: {
        key: 'videos',
        name: 'Video Gallery',
        description: `Provide videos of your organization.`,
        fields: {
          field_org_video_cover_image: 'cover',
          field_org_video_title: 'coverTitle',
          field_org_video_url: 'source',
        },
      },
      locations: {
        key: 'further_locations',
        name: 'Further locations',
        description: `Provide information about further locations where the
        organization is located. These will be shown in a map in your profile page.`,
        fields: {
          field_org_location_name: 'name',
          field_org_location_address: {
            name: 'address',
            fields: {
              countryCode: 'countryCode',
              addressLine1: 'addressLine1',
              locality: 'locality',
              postalCode: 'zip',
            },
          },
        },
      },
      faq: {
        key: 'faq',
        name: 'FAQ',
        description: `Provide frequently asked questions. These will be shown in a FAQ section in your profile page.`,
        fields: {
          field_org_question: 'question',
          field_org_answer: 'answer',
        },
      },
      attachments: {
        key: 'attachments',
        name: 'Attachments',
        description: `Provide files that can be downloaded by the users.
        Supported filetypes: pdf, jpg, jpeg, png, webp. Maximum upload size 50 MB.`,
        fields: {
          field_org_attachments: 'attachments',
        },
      },
    },
    ORGANIZATION_PAGE_SHOW_CHILDREN: false,
    DETAIL_NOFOLLOW_EXTERNAL_PRESENTATION_LINKS: false,
    DETAIL_PLAINTEXT_EXTERNAL_PRESENTATION_LINKS: false,
    CUSTOMER_PROFILE_FIELDS: {
      info: {
        key: 'customer_profile_info',
        name: 'Customer profile',
        description: `Provide billing information. Information added here will be collected and filled together with the order that will
        be sent to you.`,
        fields: {
          field_customer_company_name: 'companyName',
          field_customer_email: 'email',
          field_customer_firstname: 'firstName',
          field_customer_lastname: 'lastName',
          address: {
            name: 'address',
            fields: {
              countryCode: 'countryCode',
              administrativeArea: 'administrativeArea',
              addressLine1: 'addressLine1',
              addressLine2: 'addressLine2',
              locality: 'locality',
              postalCode: 'zip',
            },
          },
          field_customer_vat_number: 'vatNumber',
        },
      },
    },
    HIDE_GEO_SEARCH: false,
    HIDE_KEYWORD_SEARCH: false,
    GEO_INFO: {
      radius: {
        options: [5, 25, 50, 100, 200],
        defaultValue: 100,
        unit: 'km',
        unitMultiplier: 1,
        hideForLocationType: [
          'country',
          'administrative_area_level_1',
          'administrative_area_level_2',
          'administrative_area_level_3',
        ],
      },
      types: ['(regions)'],
      fixtures: null,
    },
    SHOW_ONLY_FEATURED_ORGANIZATIONS: false,
    FEATURED_ORGANIZATIONS_SETTINGS: {
      RANGE: {
        FIRST: 0,
        LAST: 4,
      },
    },
    SHOW_PREMIUM_INDICATIONS: true,
    ORGANIZATION_CREDITS_PAGE: '/contact',
    ORGANIZATION_SUBSCRIPTIONS_PAGE: '/contact',
    SHOW_SUBSCRIPTIONS_FROM_ALL_FRONTENDS: false,
    JOB_MANAGER_SHOW_FRONTENDS: false,
    ORGANIZATION_FLEX_ADDRESS_ENABLED: false,
    RECRUITER_FEATURE_ACTIVE: true,
    RECRUITER_DASHBOARD_SHOW_APPLICATIONS: false,
    ORGANIZATION_TEASER_FIELDS: {
      organizationLocation: true,
      industry: true,
      size: true,
      organizationJobsCount: true,
    },
    ORGANIZATION_PROFILE_INFO_BOX_FIELDS: {
      organizationLocation: true,
      industry: true,
      socialLinks: true,
    },
    ORGANIZATION_TEASER_JOBS_LINK: true,
    ORGANIZATION_TEASER_LAYOUT: {
      RATIO_HEIGHT: 500,
      RATIO_WIDTH: 1000,
    },
    TRAINING_ORGANIZATIONS_SETTINGS: {
      RANGE: {
        FIRST: 0,
        LAST: 50,
      },
      SLIDES_TO_SHOW: 5,
      SHOW_PLAY_PAUSE_BUTTON: true,
      SHOW_DOTS: true,
      IMAGE_STYLE: 'job_squared_logo_medium',
    },
    ORGANIZATION_JOB_SEARCH_EXTRA_FILTERS_ENABLED: false,
    ORGANIZATION_JOB_SEARCH_EXTRA_FILTERS: {
      id: true,
      location: true,
      source: true,
      employment_type: true,
      application_workflow: true,
      frontend: true,
    },
    ORGANIZATION_TEASER_DEFAULT_COVER_IMAGE: false,
    REGISTER: {
      register_recruiter: {
        key: 'register_recruiter_form',
        fields: {},
      },
    },
  },
  server: {},
};
